<div class="name-header">
  <i class="far fa-user-circle btn-header-icon"></i>
  <div><span>{{ "common.welcome" | translate }}, </span><span class="highlight">{{ user?.firstName }}</span></div>
</div>
<div class="profile-actions">
  <button mat-button class="sm-btn" (click)="onProfileInformation()">{{ "common.profile_information" | translate }}</button>
  @if (!user?.isSSOUser) {
    <button mat-button class="sm-btn" (click)="onPasswordChange()">{{ "common.change_password" | translate }}</button>
  }
</div>
<div class="profile-actions">
  <button mat-button (click)="onLogout()">
    <i class="fas fa-cog"></i>
    {{ "sidebar.log_out" | translate }}
  </button>
</div>
